/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jumpy_Round_Koala_RadiateInputs */

const en_jumpy_round_koala_radiate = /** @type {(inputs: Jumpy_Round_Koala_RadiateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time`)
};

/**
* | output |
* | --- |
* | "Time" |
*
* @param {Jumpy_Round_Koala_RadiateInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const jumpy_round_koala_radiate = /** @type {((inputs?: Jumpy_Round_Koala_RadiateInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jumpy_Round_Koala_RadiateInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_jumpy_round_koala_radiate(inputs)
});